import styled from 'styled-components';

export const ChooseContainer = styled.div`
  display: grid;
  /* Dois cards por nível: foto x preenchimento de dados e, depois,
     CNH/Passaporte x face. Com 3 colunas a terceira ficava vazia e os cards
     encostavam à esquerda. */
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: stretch;
  gap: 1rem;
  width: 100%;

  button {
    background: #fff;
    border: 1px solid var(--stone-300);
    padding: 1.5rem 1.25rem;
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-sm);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    width: 100%;
    min-height: 180px;
    font-family: var(--font-sans);
    font-weight: 700;
    font-size: 0.9rem;
    color: var(--foreground);
    text-align: center;

    transition: border-color 0.18s, box-shadow 0.18s;

    &:hover {
      border-color: var(--primary);
      box-shadow: 0 0 0 3px rgba(255, 188, 3, 0.3);
    }

    img,
    svg {
      width: 40px;
      height: 40px;
      color: var(--stone-700);
    }
  }

  @media (max-width: 720px) {
    grid-template-columns: 1fr;

    button {
      min-height: 0;
      flex-direction: row;
      justify-content: flex-start;
      gap: 1rem;
      text-align: left;
      padding: 1rem 1.25rem;
    }
  }
`;
